import { create } from "zustand";

export type PhoneConfirmSubmit = (code: string) => void | Promise<void>;

interface PhoneConfirmStore {
  open: boolean;
  onSubmit: PhoneConfirmSubmit;
  setOpen: (value: boolean) => void;
  setOnSubmit: (value: PhoneConfirmSubmit) => void;
}

export const usePhoneConfirmStore = create<PhoneConfirmStore>((set) => ({
  open: false,
  onSubmit: () => {},
  setOpen: (value) => {
    set({ open: value });
  },
  setOnSubmit: (value) => {
    set({ onSubmit: value });
  },
}));
